// extracted by mini-css-extract-plugin
export default {"drawer":"DrawerWrapper_drawer__OdpfA","wrapper":"DrawerWrapper_wrapper__4MUzz","body":"DrawerWrapper_body__2tXQb"};